// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/substation.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "structs.structs";

export interface Substation {
  id: string;
  owner: string;
  creator: string;
  name: string;
  pfp: string;
  deletionPending: boolean;
  deletionMigrationSubstationId: string;
}

function createBaseSubstation(): Substation {
  return {
    id: "",
    owner: "",
    creator: "",
    name: "",
    pfp: "",
    deletionPending: false,
    deletionMigrationSubstationId: "",
  };
}

export const Substation: MessageFns<Substation> = {
  encode(message: Substation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.owner !== "") {
      writer.uint32(18).string(message.owner);
    }
    if (message.creator !== "") {
      writer.uint32(26).string(message.creator);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.pfp !== "") {
      writer.uint32(42).string(message.pfp);
    }
    if (message.deletionPending !== false) {
      writer.uint32(48).bool(message.deletionPending);
    }
    if (message.deletionMigrationSubstationId !== "") {
      writer.uint32(58).string(message.deletionMigrationSubstationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Substation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubstation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.pfp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.deletionPending = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.deletionMigrationSubstationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Substation {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      owner: isSet(object.owner) ? globalThis.String(object.owner) : "",
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      pfp: isSet(object.pfp) ? globalThis.String(object.pfp) : "",
      deletionPending: isSet(object.deletionPending) ? globalThis.Boolean(object.deletionPending) : false,
      deletionMigrationSubstationId: isSet(object.deletionMigrationSubstationId)
        ? globalThis.String(object.deletionMigrationSubstationId)
        : "",
    };
  },

  toJSON(message: Substation): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.owner !== "") {
      obj.owner = message.owner;
    }
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.pfp !== "") {
      obj.pfp = message.pfp;
    }
    if (message.deletionPending !== false) {
      obj.deletionPending = message.deletionPending;
    }
    if (message.deletionMigrationSubstationId !== "") {
      obj.deletionMigrationSubstationId = message.deletionMigrationSubstationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Substation>, I>>(base?: I): Substation {
    return Substation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Substation>, I>>(object: I): Substation {
    const message = createBaseSubstation();
    message.id = object.id ?? "";
    message.owner = object.owner ?? "";
    message.creator = object.creator ?? "";
    message.name = object.name ?? "";
    message.pfp = object.pfp ?? "";
    message.deletionPending = object.deletionPending ?? false;
    message.deletionMigrationSubstationId = object.deletionMigrationSubstationId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
